var App = App || {};

App.ComponentFeatures = (function ($) {
    'use strict';

    function init() {

        $(".component-features").each(function () {

            const image = $(this).find(".component-features-ui-images");
            const indicator = $(this).find(".component-features-ui-indicator > div");
            const accordion = $(this).find(".component-features-ui-accordion .accordion");
            const collapses = accordion.find(".collapse");

            $(window).on("resize", function () {
                if (accordion.find(".collapse.show").length) {
                    const collapse = accordion.find(".collapse.show").first();
                    UpdateIndicator(collapse);
                }
            });

            collapses.on("show.bs.collapse", function () {
                UpdateImage($(this));
            });

            collapses.on("shown.bs.collapse", function () {
                UpdateIndicator($(this));
            });

            collapses.first().collapse("show");

            function UpdateIndicator(collapse) {
                const distance = collapse.parents(".accordion-item").position().top;
                const height = collapse.parents(".accordion-item").outerHeight();
                indicator.stop().animate({ top: distance, height: height }, 200)
            }

            function UpdateImage(collapse) {
                const imageUrl = collapse.attr("data-image");
                image.find("img[src='" + imageUrl + "']").first().fadeIn(300).siblings().fadeOut(300);
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ComponentFeatures.init();
});